var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 80,
    viewBox: "0 0 67 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.998 67.4809L52.7164 66.776L47.1551 79.9346L27.8867 49.2834L47.7295 36.8037L66.998 67.4809Z",
    fill: "url(#paint0_linear_8308_55035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7278 48.081L48.1607 77.4267L47.6385 78.7321L28.7617 48.7076L29.7278 48.081Z",
    fill: "url(#paint1_linear_8308_55035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7903 37.3734L65.6409 67.3979L64.2572 67.3457L45.8242 37.9739L46.7903 37.3734Z",
    fill: "url(#paint2_linear_8308_55035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.4853L14.2816 66.7804L19.8428 79.939L39.1373 49.2879L19.2684 36.8081L0 67.4853Z",
    fill: "url(#paint3_linear_8308_55035)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2337 48.0922L18.8008 77.4379L19.3491 78.7433L38.1997 48.7188L37.2337 48.0922Z",
    fill: "url(#paint4_linear_8308_55035)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1932 37.3778L1.31641 67.4024L2.70018 67.3501L21.1592 37.9783L20.1932 37.3778Z",
    fill: "url(#paint5_linear_8308_55035)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8728 32.4004C65.8728 50.2845 51.3562 64.8008 33.4716 64.8008C15.5608 64.8008 1.07031 50.2845 1.07031 32.4004C1.07031 14.4901 15.5608 0 33.4716 0C51.3562 0 65.8728 14.4901 65.8728 32.4004Z",
    fill: "url(#paint6_linear_8308_55035)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6162 32.4078C61.6162 47.9161 49.0317 60.5003 33.5229 60.5003C17.9881 60.5003 5.42969 47.9161 5.42969 32.4078C5.42969 16.8734 17.9881 4.31531 33.5229 4.31531C49.0317 4.31531 61.6162 16.8734 61.6162 32.4078Z",
    fill: "url(#paint7_linear_8308_55035)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7121 32.4106C60.7121 47.4489 48.5192 59.6415 33.4804 59.6415C18.4155 59.6415 6.22266 47.4489 6.22266 32.4106C6.22266 17.3461 18.4155 5.15355 33.4804 5.15355C48.5192 5.15355 60.7121 17.3461 60.7121 32.4106Z",
    fill: "url(#paint8_linear_8308_55035)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4872 32.6547C58.4872 46.6226 47.182 57.9275 33.2137 57.9275C19.2454 57.9275 7.91406 46.6226 7.91406 32.6547C7.91406 18.6868 19.2454 7.35577 33.2137 7.35577C47.182 7.35577 58.4872 18.6868 58.4872 32.6547Z",
    fill: "url(#paint9_linear_8308_55035)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5622 32.5836C49.5622 41.4507 42.367 48.646 33.4998 48.646C24.6178 48.646 17.4375 41.4507 17.4375 32.5836C17.4375 23.7016 24.6178 16.5213 33.4998 16.5213C42.367 16.5213 49.5622 23.7016 49.5622 32.5836Z",
    fill: "url(#paint10_linear_8308_55035)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7267 32.5907C47.7267 40.4495 41.3662 46.81 33.5074 46.81C25.6486 46.81 19.2734 40.4495 19.2734 32.5907C19.2734 24.7319 25.6486 18.3567 33.5074 18.3567C41.3662 18.3567 47.7267 24.7319 47.7267 32.5907Z",
    fill: "url(#paint11_linear_8308_55035)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3065 32.5834C41.3065 36.8903 37.8117 40.3851 33.5048 40.3851C29.1907 40.3851 25.7031 36.8903 25.7031 32.5834C25.7031 28.2693 29.1907 24.7817 33.5048 24.7817C37.8117 24.7817 41.3065 28.2693 41.3065 32.5834Z",
    fill: "url(#paint12_linear_8308_55035)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4672 32.5864C39.4672 35.882 36.7999 38.5493 33.5042 38.5493C30.2086 38.5493 27.5352 35.882 27.5352 32.5864C27.5352 29.2907 30.2086 26.6173 33.5042 26.6173C36.7999 26.6173 39.4672 29.2907 39.4672 32.5864Z",
    fill: "url(#paint13_linear_8308_55035)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2964 30.6709L11.5088 32.2641L9.8125 32.519L11.0241 33.7936L10.7212 35.578L12.2964 34.7495L13.8109 35.578L13.508 33.7936L14.7196 32.519L13.0234 32.2641L12.2964 30.6709Z",
    fill: "#FFD54F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0151 30.6709L53.2276 32.2641L51.5312 32.519L52.7429 33.7936L52.44 35.578L54.0151 34.7495L55.5297 35.578L55.2268 33.7936L56.4384 32.519L54.7421 32.2641L54.0151 30.6709Z",
    fill: "#FFD54F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8308_55035",
    x1: 61.4065,
    y1: 28.0109,
    x2: 80.7977,
    y2: 58.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8308_55035",
    x1: 495.227,
    y1: -244.624,
    x2: 514.211,
    y2: -214.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8308_55035",
    x1: 512.292,
    y1: -255.343,
    x2: 531.276,
    y2: -225.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8308_55035",
    x1: 5.59802,
    y1: 28.0156,
    x2: -13.7932,
    y2: 58.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8308_55035",
    x1: -428.267,
    y1: -244.618,
    x2: -447.251,
    y2: -214.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8308_55035",
    x1: -445.346,
    y1: -255.35,
    x2: -464.33,
    y2: -225.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8308_55035",
    x1: 33.1549,
    y1: -32.8312,
    x2: 96.6157,
    y2: 30.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8308_55035",
    x1: 89.9792,
    y1: 32.1188,
    x2: 34.4941,
    y2: 87.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FDE79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#E1C575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8308_55035",
    x1: 88.2482,
    y1: 32.1302,
    x2: 34.4223,
    y2: 85.9575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DDA820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A56613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB6F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8308_55035",
    x1: 84.0301,
    y1: 32.3939,
    x2: 34.0868,
    y2: 82.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8308_55035",
    x1: 65.7787,
    y1: 32.4184,
    x2: 34.0543,
    y2: 64.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FDE79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#E1C575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8308_55035",
    x1: 62.0976,
    y1: 32.4439,
    x2: 33.9979,
    y2: 60.5437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8308_55035",
    x1: 49.1831,
    y1: 32.5032,
    x2: 33.7741,
    y2: 47.9122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FACC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#FDE79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#E1C575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACC35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8308_55035",
    x1: 45.4937,
    y1: 32.5248,
    x2: 33.7099,
    y2: 44.3086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#101920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191620"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.b05edd5b706a005f339b489df3948801.svg";
export { ForwardRef as ReactComponent };